import jsonp from 'jsonp';

export interface RequestJsonpOptions {
  timeout?: number;
}

export function requestJsonp<T>(url: string, options: RequestJsonpOptions = {}): Promise<T> {
  return new Promise((resolve, reject) => {
    jsonp(url, { timeout: options.timeout }, (error, data: T) => {
      if (error) {
        reject(error);
        return;
      }
      resolve(data);
    });
  });
}
